import React from "react";

export default function MakePaymentShimmer() {
  return (
    <div tw="flex flex-col gap-[24px] w-full">
      <div tw="animate-pulse h-[40px] w-[40px] rounded-full bg-containment-tertiary mx-auto" />

      <div tw="flex flex-col gap-[4px] items-center justify-center">
        <div tw="animate-pulse h-[36px] w-[250px] rounded-[999px] bg-containment-tertiary "></div>
        <div tw="animate-pulse h-[20px] w-[168px] rounded-[999px] bg-containment-tertiary"></div>
      </div>

      <div tw="animate-pulse flex flex-col p-[16px] gap-[24px] w-full rounded-[16px] bg-containment-tertiary">
        <div tw="animate-pulse h-[36px] w-[408px] rounded-[999px] bg-containment-primary mb-[2px]"></div>

        {[1, 2, 3].map((item) => (
          <div tw="flex items-center gap-[16px]" key={item}>
            <div tw="animate-pulse h-[68px] w-[2px] rounded-full bg-containment-primary"></div>
            <div tw="w-full">
              <div tw="animate-pulse h-[20px] w-[168px] rounded-full bg-containment-primary mb-[4px]"></div>
              <div tw="animate-pulse h-[20px] w-full rounded-full bg-containment-primary mb-[8px]"></div>
              <div tw="animate-pulse h-[16px] w-[134px] rounded-full bg-containment-primary"></div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
